export enum Ms {
    MyAssetPlanner = 'my-asset-planner',
    Organizations = 'organizations',
    Reporting = 'reporting',
    SSE = 'sse'
}
